import React, { useState } from 'react';
import styled from '@emotion/styled';
import useOfflineGoalData from '@api/hooks/enquiry/useOfflineGoalData';
import useWindowSize from '@hooks/useWindowSize';
import { Spacings } from '@styles/index';
import CircularLoader from '@base/CircularLoader/CircularLoader';
import DialogEnquiryStaticInfo from './DialogEnquiryStaticInfo';
import DialogEnquiryForm from './DialogEnquiryForm';
import DialogEnquiryThankyou from './DialogEnquiryThankYou';

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
`;

const EnquiryFormWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  height: 510px;
`;

const LoaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`;

const LeftContainer = styled.div`
  width: 384px;
  height: 100%;
  background-color: var(--color-i-white-99);
  padding: ${Spacings.SPACING_8B};
`;

const RightContainer = styled.div`
  width: 416px;
  background-color: var(--color-i-white);
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_11B} ${Spacings.SPACING_8B}
    ${Spacings.SPACING_11B};
`;

function AllCentreDialogEnquiry({ closeDialogHandler, cmsData }) {
  const { offlineGoals, isGoalDataLoading } = useOfflineGoalData();
  const isLoading = isGoalDataLoading;

  const { isTablet, isMobile } = useWindowSize();
  const [thankyouPage, showThankyouPage] = useState(false);
  const goalsData = [];
  offlineGoals?.goal_uids?.forEach((uid, index) =>
    goalsData.push({
      id: index + 1,
      value: uid,
      label: offlineGoals.goal_names[index]
    })
  );

  if (isLoading) {
    return (
      <Container>
        <EnquiryFormWrapper>
          <LoaderWrapper>
            <CircularLoader />
          </LoaderWrapper>
        </EnquiryFormWrapper>
      </Container>
    );
  }

  return (
    <Container>
      <EnquiryFormWrapper>
        <LeftContainer>
          {!isMobile && !isTablet && (
            <DialogEnquiryStaticInfo closeDialogHandler={closeDialogHandler} />
          )}
        </LeftContainer>
        <RightContainer>
          {thankyouPage ? (
            <DialogEnquiryThankyou />
          ) : (
            <DialogEnquiryForm
              cmsData={cmsData}
              offlineGoals={goalsData}
              showThankyouPage={showThankyouPage}
              // formType={formType}
            />
          )}
        </RightContainer>
      </EnquiryFormWrapper>
    </Container>
  );
}

export default AllCentreDialogEnquiry;
